var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCompareArrow = function SvgIconCompareArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.405 18.068"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.964 14.894H0v-2.72h10.964V9l5.441 4.534-5.441 4.534zM0 4.534 5.441 0v3.174h10.964v2.721H5.441v3.173z"
  })));
};
export default SvgIconCompareArrow;